import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { usePortal, API_BASE } from './HousePortalLayout';

const T = {
  en: {
    back: 'Back to Listings',
    beds: 'Bedrooms', baths: 'Bathrooms', area: 'Area', floor: 'Floor', furnishing: 'Furnishing',
    description: 'Description', aiSelling: 'AI Selling Points', locationTitle: 'Location',
    amenities: 'Amenities', schedule: 'Schedule a Viewing', virtualTour: 'Start Virtual Tour',
    askAnything: 'Ask anything about this property',
    sendMsg: 'Send', chatPlaceholder: 'Type your question...',
    inquiry: 'Interested? Get in Touch',
    name: 'Full Name', email: 'Email', phone: 'Phone', message: 'Message',
    submit: 'Send Inquiry', sent: 'Inquiry Sent!',
    similar: 'Similar Properties',
    viewDetails: 'View Details',
    nearbyTransit: 'Nearby Transit',
    sqm: 'sqm', hot: 'HOT',
    loading: 'Loading property details...',
    notFound: 'Property not found',
    perMonth: '/month',
    forSale: 'For Sale', forRent: 'For Rent',
    googleMap: 'Open Google Maps',
    lineAsk: 'Ask on LINE',
    sourceSite: 'View Photos on Source Site',
    myRating: 'My Rating',
    rating: 'Rating',
    rateNow: 'Click a star to rate',
    clearRating: 'Clear',
    nearbyPois: 'Nearby Facilities',
    poiHint: 'Click a card for Google Maps location & photos',
    nearbyStays: 'Nearby Stays (Hotels & Airbnb)',
    stayHint: 'Stay nearby first to experience the neighbourhood',
    similarHint: 'Other options in the same district with comparable price & area',
    ping: 'ping',
    perPing: 'per ping',
    perSqm: 'THB/sqm',
    officeTag: 'Office', coworkingTag: 'Coworking', rentTag: 'Rent',
    areaPing: 'Area (ping)',
    source: 'Source',
    backToListings: 'Back',
    mapFallback: 'Location preview',
    noRatingText: 'No ratings yet',
    reasons: { district: 'Same area', districtNear: 'Nearby area', price: 'Similar price', area: 'Similar area', unitPrice: 'Similar price/sqm', source: 'Same source' },
  },
  th: {
    back: '\u0e01\u0e25\u0e31\u0e1a\u0e44\u0e1b\u0e23\u0e32\u0e22\u0e01\u0e32\u0e23',
    beds: '\u0e2b\u0e49\u0e2d\u0e07\u0e19\u0e2d\u0e19', baths: '\u0e2b\u0e49\u0e2d\u0e07\u0e19\u0e49\u0e33', area: '\u0e1e\u0e37\u0e49\u0e19\u0e17\u0e35\u0e48', floor: '\u0e0a\u0e31\u0e49\u0e19', furnishing: '\u0e40\u0e1f\u0e2d\u0e23\u0e4c\u0e19\u0e34\u0e40\u0e08\u0e2d\u0e23\u0e4c',
    description: '\u0e23\u0e32\u0e22\u0e25\u0e30\u0e40\u0e2d\u0e35\u0e22\u0e14', aiSelling: 'AI \u0e08\u0e38\u0e14\u0e40\u0e14\u0e48\u0e19', locationTitle: '\u0e17\u0e33\u0e40\u0e25',
    amenities: '\u0e2a\u0e34\u0e48\u0e07\u0e2d\u0e33\u0e19\u0e27\u0e22\u0e04\u0e27\u0e32\u0e21\u0e2a\u0e30\u0e14\u0e27\u0e01', schedule: '\u0e19\u0e31\u0e14\u0e2b\u0e21\u0e32\u0e22\u0e14\u0e39\u0e2b\u0e49\u0e2d\u0e07', virtualTour: '\u0e40\u0e23\u0e34\u0e48\u0e21\u0e17\u0e31\u0e27\u0e23\u0e4c\u0e40\u0e2a\u0e21\u0e37\u0e2d\u0e19\u0e08\u0e23\u0e34\u0e07',
    askAnything: '\u0e16\u0e32\u0e21\u0e2d\u0e30\u0e44\u0e23\u0e01\u0e47\u0e44\u0e14\u0e49\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e01\u0e31\u0e1a\u0e2d\u0e2a\u0e31\u0e07\u0e2b\u0e32\u0e23\u0e34\u0e21\u0e17\u0e23\u0e31\u0e1e\u0e22\u0e4c\u0e19\u0e35\u0e49',
    sendMsg: '\u0e2a\u0e48\u0e07', chatPlaceholder: '\u0e1e\u0e34\u0e21\u0e1e\u0e4c\u0e04\u0e33\u0e16\u0e32\u0e21...',
    inquiry: '\u0e2a\u0e19\u0e43\u0e08? \u0e15\u0e34\u0e14\u0e15\u0e48\u0e2d\u0e40\u0e23\u0e32',
    name: '\u0e0a\u0e37\u0e48\u0e2d', email: '\u0e2d\u0e35\u0e40\u0e21\u0e25', phone: '\u0e42\u0e17\u0e23\u0e28\u0e31\u0e1e\u0e17\u0e4c', message: '\u0e02\u0e49\u0e2d\u0e04\u0e27\u0e32\u0e21',
    submit: '\u0e2a\u0e48\u0e07\u0e04\u0e33\u0e23\u0e49\u0e2d\u0e07\u0e02\u0e2d', sent: '\u0e2a\u0e48\u0e07\u0e41\u0e25\u0e49\u0e27!',
    similar: '\u0e2d\u0e2a\u0e31\u0e07\u0e2b\u0e32\u0e23\u0e34\u0e21\u0e17\u0e23\u0e31\u0e1e\u0e22\u0e4c\u0e17\u0e35\u0e48\u0e04\u0e25\u0e49\u0e32\u0e22',
    viewDetails: '\u0e14\u0e39\u0e23\u0e32\u0e22\u0e25\u0e30\u0e40\u0e2d\u0e35\u0e22\u0e14',
    nearbyTransit: '\u0e23\u0e30\u0e1a\u0e1a\u0e02\u0e19\u0e2a\u0e48\u0e07\u0e43\u0e01\u0e25\u0e49\u0e40\u0e04\u0e35\u0e22\u0e07',
    sqm: '\u0e15\u0e23.\u0e21.', hot: 'HOT',
    loading: '\u0e01\u0e33\u0e25\u0e31\u0e07\u0e42\u0e2b\u0e25\u0e14...',
    notFound: '\u0e44\u0e21\u0e48\u0e1e\u0e1a\u0e2d\u0e2a\u0e31\u0e07\u0e2b\u0e32\u0e23\u0e34\u0e21\u0e17\u0e23\u0e31\u0e1e\u0e22\u0e4c',
    perMonth: '/\u0e40\u0e14\u0e37\u0e2d\u0e19',
    forSale: '\u0e02\u0e32\u0e22', forRent: '\u0e40\u0e0a\u0e48\u0e32',
    googleMap: '\u0e40\u0e1b\u0e34\u0e14 Google Maps',
    lineAsk: '\u0e2a\u0e2d\u0e1a\u0e16\u0e32\u0e21\u0e17\u0e32\u0e07 LINE',
    sourceSite: '\u0e14\u0e39\u0e23\u0e39\u0e1b\u0e08\u0e32\u0e01\u0e40\u0e27\u0e47\u0e1a\u0e41\u0e2b\u0e25\u0e48\u0e07\u0e02\u0e49\u0e2d\u0e21\u0e39\u0e25',
    myRating: '\u0e04\u0e30\u0e41\u0e19\u0e19\u0e02\u0e2d\u0e07\u0e09\u0e31\u0e19',
    rating: '\u0e04\u0e30\u0e41\u0e19\u0e19',
    rateNow: '\u0e04\u0e25\u0e34\u0e01\u0e14\u0e32\u0e27\u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e43\u0e2b\u0e49\u0e04\u0e30\u0e41\u0e19\u0e19',
    clearRating: '\u0e25\u0e49\u0e32\u0e07',
    nearbyPois: '\u0e2a\u0e34\u0e48\u0e07\u0e2d\u0e33\u0e19\u0e27\u0e22\u0e43\u0e01\u0e25\u0e49\u0e40\u0e04\u0e35\u0e22\u0e07',
    poiHint: '\u0e04\u0e25\u0e34\u0e01\u0e1a\u0e31\u0e15\u0e23\u0e4c\u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e14\u0e39\u0e15\u0e33\u0e41\u0e2b\u0e19\u0e48\u0e07\u0e43\u0e19 Google Maps',
    nearbyStays: '\u0e17\u0e35\u0e48\u0e1e\u0e31\u0e01\u0e43\u0e01\u0e25\u0e49\u0e40\u0e04\u0e35\u0e22\u0e07 (\u0e42\u0e23\u0e07\u0e41\u0e23\u0e21 & Airbnb)',
    stayHint: '\u0e1e\u0e31\u0e01\u0e43\u0e01\u0e25\u0e49\u0e41\u0e23\u0e01\u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e2a\u0e31\u0e21\u0e1c\u0e31\u0e2a\u0e0a\u0e35\u0e27\u0e34\u0e15\u0e43\u0e19\u0e1e\u0e37\u0e49\u0e19\u0e17\u0e35\u0e48',
    similarHint: '\u0e15\u0e31\u0e27\u0e40\u0e25\u0e37\u0e2d\u0e01\u0e2d\u0e37\u0e48\u0e19\u0e43\u0e19\u0e40\u0e02\u0e15\u0e14\u0e35\u0e22\u0e27\u0e01\u0e31\u0e19\u0e23\u0e32\u0e04\u0e32\u0e41\u0e25\u0e30\u0e1e\u0e37\u0e49\u0e19\u0e17\u0e35\u0e48\u0e43\u0e01\u0e25\u0e49\u0e40\u0e04\u0e35\u0e22\u0e07',
    ping: '\u0e1e\u0e37\u0e49\u0e19\u0e17\u0e35\u0e48',
    perPing: '/\u0e1e\u0e37\u0e49\u0e19\u0e17\u0e35\u0e48',
    perSqm: '\u0e1a\u0e32\u0e17/\u0e15\u0e23.\u0e21.',
    officeTag: '\u0e2a\u0e33\u0e19\u0e31\u0e01\u0e07\u0e32\u0e19', coworkingTag: '\u0e2a\u0e31\u0e07\u0e04\u0e21', rentTag: '\u0e40\u0e0a\u0e48\u0e32',
    areaPing: '\u0e1e\u0e37\u0e49\u0e19\u0e17\u0e35\u0e48 (\u0e1e\u0e37\u0e49\u0e19\u0e17\u0e35\u0e48)',
    source: '\u0e41\u0e2b\u0e25\u0e48\u0e07\u0e02\u0e49\u0e2d\u0e21\u0e39\u0e25',
    backToListings: '\u0e01\u0e25\u0e31\u0e1a',
    mapFallback: '\u0e15\u0e33\u0e41\u0e2b\u0e19\u0e48\u0e07',
    noRatingText: '\u0e22\u0e31\u0e07\u0e44\u0e21\u0e48\u0e21\u0e35\u0e04\u0e30\u0e41\u0e19\u0e19',
    reasons: { district: '\u0e40\u0e02\u0e15\u0e14\u0e35\u0e22\u0e27\u0e01\u0e31\u0e19', districtNear: '\u0e40\u0e02\u0e15\u0e43\u0e01\u0e25\u0e49\u0e40\u0e04\u0e35\u0e22\u0e07', price: '\u0e23\u0e32\u0e04\u0e32\u0e43\u0e01\u0e25\u0e49\u0e04\u0e35\u0e22\u0e07', area: '\u0e1e\u0e37\u0e49\u0e19\u0e17\u0e35\u0e48\u0e43\u0e01\u0e25\u0e49\u0e04\u0e35\u0e22\u0e07', unitPrice: '\u0e23\u0e32\u0e04\u0e32/\u0e15\u0e23.\u0e21. \u0e43\u0e01\u0e25\u0e49\u0e04\u0e35\u0e22\u0e07', source: '\u0e41\u0e2b\u0e25\u0e48\u0e07\u0e14\u0e35\u0e22\u0e27\u0e01\u0e31\u0e19' },
  },
  zh: {
    back: '\u8fd4\u56de\u5217\u8868',
    beds: '\u81e5\u5ba4', baths: '\u6d74\u5ba4', area: '\u9762\u7a4d', floor: '\u6a13\u5c64', furnishing: '\u88dd\u4fee',
    description: '\u63cf\u8ff0', aiSelling: 'AI \u8ce3\u9ede', locationTitle: '\u4f4d\u7f6e',
    amenities: '\u8a2d\u65bd', schedule: '\u9810\u7d04\u770b\u623f', virtualTour: '\u958b\u59cb\u865b\u64ec\u5c0e\u89bd',
    askAnything: '\u554f\u4efb\u4f55\u95dc\u65bc\u6b64\u623f\u7522\u7684\u554f\u984c',
    sendMsg: '\u767c\u9001', chatPlaceholder: '\u8f38\u5165\u60a8\u7684\u554f\u984c...',
    inquiry: '\u6709\u8208\u8da3\uff1f\u806f\u7e6b\u6211\u5011',
    name: '\u59d3\u540d', email: '\u96fb\u5b50\u90f5\u4ef6', phone: '\u96fb\u8a71', message: '\u7559\u8a00',
    submit: '\u63d0\u4ea4\u8a62\u554f', sent: '\u5df2\u63d0\u4ea4\uff01',
    similar: '\u76f8\u4f3c\u623f\u7522',
    viewDetails: '\u67e5\u770b\u8a73\u60c5',
    nearbyTransit: '\u9644\u8fd1\u4ea4\u901a',
    sqm: '\u5e73\u65b9\u7c73', hot: 'HOT',
    loading: '\u6b63\u5728\u8f09\u5165...',
    notFound: '\u672a\u627e\u5230\u623f\u7522',
    perMonth: '/\u6708',
    forSale: '\u51fa\u552e', forRent: '\u51fa\u79df',
    googleMap: '\u6253\u958b Google \u5730\u5716',
    lineAsk: 'LINE \u8a62\u554f',
    sourceSite: '\u524d\u5f80\u539f\u59cb\u7db2\u7ad9\u770b\u7167\u7247',
    myRating: '\u6211\u7684\u8a55\u5206',
    rating: '\u8a55\u5206',
    rateNow: '\u9ede\u64ca\u661f\u661f\u8a55\u5206',
    clearRating: '\u6e05\u9664',
    nearbyPois: '\u9644\u8fd1\u8a2d\u65bd',
    poiHint: '\u9ede\u64ca\u5361\u7247\u67e5\u770b Google \u5730\u5716\u4f4d\u7f6e\u8207\u5834\u5730\u7167\u7247',
    nearbyStays: '\u9644\u8fd1\u4f4f\u5bbf\u9ad4\u9a57 (\u98ef\u5e97 & Airbnb)',
    stayHint: '\u5148\u4f4f\u9644\u8fd1\u9ad4\u9a57\u7576\u5730\u751f\u6d3b\u6a5f\u80fd\uff0c\u518d\u6c7a\u5b9a\u8fa6\u516c\u5ba4\u5730\u9ede',
    similarHint: '\u8207\u6b64\u7269\u4ef6\u540c\u5340\u57df\u3001\u50f9\u683c\u8207\u9762\u7a4d\u76f8\u8fd1\u7684\u5176\u4ed6\u9078\u64c7',
    ping: '\u576a',
    perPing: '/\u576a',
    perSqm: '\u6cf0\u9291/\u5e73\u65b9\u7c73',
    officeTag: '\u8fa6\u516c\u5ba4', coworkingTag: '\u5171\u4eab\u8fa6\u516c', rentTag: '\u79df\u8cc1',
    areaPing: '\u9762\u7a4d (\u576a)',
    source: '\u8cc7\u6599\u4f86\u6e90',
    backToListings: '\u8fd4\u56de',
    mapFallback: '\u4f4d\u7f6e',
    noRatingText: '\u66ab\u7121\u8a55\u5206',
    reasons: { district: '\u540c\u5340\u57df', districtNear: '\u5340\u57df\u76f8\u8fd1', price: '\u50f9\u683c\u76f8\u8fd1', area: '\u9762\u7a4d\u76f8\u8fd1', unitPrice: '\u55ae\u50f9\u76f8\u8fd1', source: '\u540c\u4f86\u6e90' },
  },
};

// Similar-property reason keys returned by the backend (Chinese) → i18n key
const REASON_KEYS = {
  '\u540c\u5340\u57df': 'district',
  '\u5340\u57df\u76f8\u8fd1': 'districtNear',
  '\u50f9\u683c\u76f8\u8fd1': 'price',
  '\u9762\u7a4d\u76f8\u8fd1': 'area',
  '\u55ae\u50f9\u76f8\u8fd1': 'unitPrice',
  '\u540c\u4f86\u6e90': 'source',
};

// 1 ping = 3.305785 sqm
const SQM_PER_PING = 3.305785;

const POI_ICONS = {
  tennis: '\ud83c\udfbe', pickleball: '\ud83c\udfd3', mall: '\ud83c\udfed', shopping_street: '\ud83d\udecd\ufe0f',
  park: '\ud83c\udf33', gym: '\ud83d\udcaa', golf: '\u26f3', fine_dining: '\ud83c\udf7d\ufe0f', convention: '\ud83c\udfdb\ufe0f',
};

const MOCK_PROPERTY = {
  id: 1,
  title: 'The Residences at Mandarin Oriental Bangkok',
  location: 'Charoenkrung Road, Riverside',
  district: 'Riverside',
  price: 45000000,
  currency: 'THB',
  bedrooms: 3,
  bathrooms: 3,
  area_sqm: 265,
  floor: 28,
  furnishing: 'Fully Furnished',
  is_featured: true,
  type: 'Condo',
  listing_type: 'sale',
  description: 'Experience the pinnacle of luxury living at The Residences at Mandarin Oriental Bangkok.',
  ai_description: 'Ultra-luxury riverside living with Mandarin Oriental service.',
  ai_selling_points: ['Mandarin Oriental branded residence', 'Unobstructed river views'],
  nearby_transit: ['Saphan Taksin BTS (800m)', 'Icon Siam Shuttle Boat'],
  amenities: ['Swimming Pool', 'Fitness Center'],
  coordinates: { lat: 13.7239, lng: 100.5130 },
  images: [],
};

const MOCK_SIMILAR = [
  { id: 2, title: 'Park Origin Thonglor', district: 'Thonglor', price: 18500000, currency: 'THB', bedrooms: 2, bathrooms: 2, area_sqm: 87, images: [] },
  { id: 4, title: 'The Diplomat Sathorn', district: 'Sathorn', price: 38000000, currency: 'THB', bedrooms: 3, bathrooms: 3, area_sqm: 198, images: [] },
];

const GALLERY_GRADIENTS = [
  'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
  'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
  'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
  'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
];

const AMENITY_ICONS = {
  'Swimming Pool': '\ud83c\udfca', 'Fitness Center': '\ud83c\udfcb\ufe0f', 'Spa': '\ud83d\udc86',
  'Concierge': '\ud83d\udc68\u200d\ud83d\udcbc', 'Restaurant': '\ud83c\udf7d\ufe0f', 'Valet Parking': '\ud83c\udd7f\ufe0f',
  'Private Lobby': '\ud83c\udfe8', 'Garden': '\ud83c\udf3f', 'Library': '\ud83d\udcda',
  'Yoga Room': '\ud83e\uddd8', 'Sauna': '\u2668\ufe0f', 'Kids Playground': '\ud83d\ude9c',
  'Security': '\ud83d\udd12', 'Rooftop': '\ud83c\udf07', 'Co-working': '\ud83d\udcbb',
};

export default function HousePortalDetail() {
  const { propertyId } = useParams();
  const { slug, lang, isMobile } = usePortal();
  const navigate = useNavigate();
  const t = T[lang] || T.en;

  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeImage, setActiveImage] = useState(0);
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState('');
  const [chatSending, setChatSending] = useState(false);
  const [similar, setSimilar] = useState([]);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
  const [formSent, setFormSent] = useState(false);
  const [fullscreen, setFullscreen] = useState(false);
  const [lineOaId, setLineOaId] = useState('');
  const [sourceMeta, setSourceMeta] = useState({});
  const [myRating, setMyRating] = useState(undefined);
  const [ratingSubmitting, setRatingSubmitting] = useState(false);

  // Stable anonymous client key for public rating
  const getClientKey = () => {
    try {
      let key = localStorage.getItem('house_portal_client_key');
      if (!key) {
        key = 'hk-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
        localStorage.setItem('house_portal_client_key', key);
      }
      return key;
    } catch {
      return 'hk-anon';
    }
  };

  const buildGMap = (p) => {
    const parts = [p.address, p.district, p.city, p.country].filter(Boolean);
    if (!parts.length) return null;
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(parts.join(', '))}`;
  };

  const buildLineChatUrl = (p) => {
    if (!lineOaId) return null;
    const oa = (lineOaId.startsWith('@') || lineOaId.startsWith('U')) ? lineOaId : `@${lineOaId}`;
    const label = p.property_type === 'coworking' ? '\u5171\u4eab\u8fa6\u516c\u5ba4' : p.property_type === 'office' ? '\u8fa6\u516c\u5ba4' : '\u4f4f\u5bb6\u7269\u4ef6';
    const text = `\u60a8\u597d\uff01\u6211\u60f3\u8a62\u554f\u9019\u500b\u7269\u4ef6\uff1a\n\ud83d\udccd ${p.title}\n\ud83c\udfe2 ${p.district || ''}\n\ud83d\udcb0 ${p.price ? `${fmtPrice(p.price)}/\u6708` : ''}\n\n\uff08\u7269\u4ef6\u7de8\u865f Ref#${p.id}\uff09\n\u65b9\u4fbf\u8acb\u5354\u52a9\u5b89\u6392\u53c3\u89c0\uff0c\u8b1d\u8b1d\uff01`;
    return `https://line.me/R/oaMessage/${oa}/?text=${encodeURIComponent(text)}`;
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Load LINE info
    fetch(`${API_BASE}/h/${slug}/line-info`)
      .then(r => r.ok ? r.json() : {})
      .then(d => { if (d.line_oa_id) setLineOaId(d.line_oa_id); })
      .catch(() => {});

    // Load source metadata for labels
    fetch(`${API_BASE}/h/${slug}/search-meta`)
      .then(r => r.ok ? r.json() : {})
      .then(d => {
        const srcMap = {};
        [...(d.office_sources || []), ...(d.home_sources || [])].forEach(s => { srcMap[s.key] = s; });
        setSourceMeta(srcMap);
      })
      .catch(() => {});

    const fetchProp = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API_BASE}/h/${slug}/properties/${propertyId}`);
        if (res.ok) {
          const data = await res.json();
          setProperty(data);
          setMyRating(data.my_rating);
        } else {
          setProperty(MOCK_PROPERTY);
        }
      } catch {
        setProperty(MOCK_PROPERTY);
      } finally {
        setLoading(false);
      }
    };
    fetchProp();

    // Fetch similar
    const fetchSimilar = async () => {
      try {
        const res = await fetch(`${API_BASE}/h/${slug}/similar?prop_id=${propertyId}&limit=6`);
        if (res.ok) {
          const data = await res.json();
          setSimilar(data.items || []);
        } else {
          setSimilar(MOCK_SIMILAR);
        }
      } catch {
        setSimilar(MOCK_SIMILAR);
      }
    };
    fetchSimilar();
  }, [slug, propertyId]);

  const handleRate = async (val) => {
    if (!property || val < 1) return;
    setRatingSubmitting(true);
    try {
      const res = await fetch(`${API_BASE}/h/${slug}/properties/${propertyId}/rating`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ rating: val, client_key: getClientKey() }),
      });
      if (res.ok) {
        const d = await res.json();
        setMyRating(d.my_rating);
        setProperty(prev => ({
          ...prev,
          rating_avg: d.rating_avg,
          rating_count: d.rating_count,
          my_rating: d.my_rating,
        }));
      }
    } catch { /* ok */ } finally {
      setRatingSubmitting(false);
    }
  };

  const sendChat = useCallback(async (msg) => {
    if (!msg.trim()) return;
    const userMsg = { role: 'user', content: msg, ts: Date.now() };
    setChatMessages(prev => [...prev, userMsg]);
    setChatInput('');
    setChatSending(true);
    try {
      const res = await fetch(`${API_BASE}/h/${slug}/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: msg,
          property_id: propertyId,
          conversation_history: chatMessages.map(m => ({ role: m.role, content: m.content })),
        }),
      });
      if (res.ok) {
        const data = await res.json();
        setChatMessages(prev => [...prev, { role: 'assistant', content: data.reply || data.message || 'Great choice! Let me help you with more details.', ts: Date.now() }]);
      } else {
        setChatMessages(prev => [...prev, { role: 'assistant', content: 'This is a lovely property. Would you like to know more about the amenities or schedule a viewing?', ts: Date.now() }]);
      }
    } catch {
      setChatMessages(prev => [...prev, { role: 'assistant', content: 'I\'d be happy to help you with details about this property.', ts: Date.now() }]);
    } finally {
      setChatSending(false);
    }
  }, [slug, propertyId, chatMessages]);

  const handleFormSubmit = async () => {
    try {
      await fetch(`${API_BASE}/h/${slug}/inquiry`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, property_id: propertyId }),
      });
    } catch { /* ok */ }
    setFormSent(true);
    setTimeout(() => setFormSent(false), 3000);
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  const fmtPrice = (price, currency = 'THB') => {
    if (!price) return '';
    if (price >= 1000000) return `${currency} ${(price / 1000000).toFixed(1)}M`;
    if (price >= 1000) return `${currency} ${(price / 1000).toFixed(0)}K`;
    return `${currency} ${price.toLocaleString()}`;
  };

  if (loading) {
    return (
      <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5fa' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: 40, height: 40, borderRadius: '50%',
            border: '3px solid rgba(0,0,0,0.06)', borderTopColor: '#e8363a',
            animation: 'houseSpinner 1s linear infinite',
            margin: '0 auto 16px',
          }} />
          <style>{`@keyframes houseSpinner { to { transform: rotate(360deg); } }`}</style>
          <p style={{ color: '#999' }}>{t.loading}</p>
        </div>
      </div>
    );
  }

  if (!property) {
    return (
      <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5fa' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 64, marginBottom: 16, opacity: 0.3 }}>&#127968;</div>
          <p style={{ color: '#999', fontSize: 18 }}>{t.notFound}</p>
          <button onClick={() => navigate(`/h/${slug}/properties`)} style={{
            marginTop: 16, background: '#1a1a2e', color: '#fff', border: 'none',
            padding: '12px 32px', borderRadius: 12, fontSize: 14, fontWeight: 600, cursor: 'pointer',
          }}>{t.back}</button>
        </div>
      </div>
    );
  }

  const p = property;
  const isCoworking = p.property_type === 'coworking';
  const isOffice = p.property_type === 'office' || isCoworking;
  const ping = p.area_sqm ? (p.area_sqm / SQM_PER_PING).toFixed(1) : null;
  const perPing = (p.price && p.area_sqm) ? Math.round(p.price / (p.area_sqm / SQM_PER_PING)) : null;
  const gmap = buildGMap(p);
  const lineUrl = buildLineChatUrl(p);
  const sourceName = sourceMeta[p.source_type]?.name_zh || sourceMeta[p.source_type]?.name || p.source_type;

  const proxyUrl = (url) => {
    if (!url) return url;
    if (url.includes('picsum.photos')) return `${API_BASE}/h/${slug}/img-proxy?url=${encodeURIComponent(url)}`;
    return url;
  };
  const images = (Array.isArray(p.images) && p.images.length > 0 ? p.images : []).map(proxyUrl);
  const imageCount = images.length || GALLERY_GRADIENTS.length;

  const specs = [
    { label: t.beds, value: p.bedrooms != null ? p.bedrooms : '-', icon: '\ud83d\udecf\ufe0f' },
    { label: t.baths, value: p.bathrooms != null ? p.bathrooms : '-', icon: '\ud83d\udebf' },
    { label: t.area, value: p.area_sqm ? `${p.area_sqm} ${t.sqm}` : '-', icon: '\u2b1c' },
    { label: t.areaPing, value: ping ? `${ping} ${t.ping}` : '-', icon: '\ud83d\udccf' },
    { label: t.furnishing, value: p.furnishing || '-', icon: '\ud83d\udecb\ufe0f' },
  ];

  return (
    <div style={{ background: '#f5f5fa' }}>

      {/* ═══ BACK BUTTON ═══ */}
      <div style={{
        maxWidth: 1200, margin: '0 auto',
        padding: isMobile ? '16px 16px 0' : '24px 48px 0',
      }}>
        <button onClick={() => navigate(`/h/${slug}/properties`)} style={{
          background: 'none', border: 'none', color: '#888',
          fontSize: 14, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6,
          padding: '8px 0',
        }}>
          &#8592; {t.back}
        </button>
      </div>

      {/* ═══ IMAGE GALLERY ═══ */}
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: isMobile ? '16px' : '16px 48px' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : '2fr 1fr',
          gridTemplateRows: isMobile ? '300px' : '420px',
          gap: 8,
          borderRadius: 20, overflow: 'hidden',
          cursor: 'pointer',
        }} onClick={() => setFullscreen(true)}>
          {/* Main image */}
          <div style={{
            background: images.length > 0 ? '#000' : GALLERY_GRADIENTS[activeImage % GALLERY_GRADIENTS.length],
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            position: 'relative', overflow: 'hidden',
          }}>
            {images.length > 0 ? (
              <img src={images[activeImage % images.length]} alt={p.title} style={{
                width: '100%', height: '100%', objectFit: 'cover',
              }} />
            ) : (
              <span style={{ fontSize: 64, opacity: 0.2 }}>&#127963;</span>
            )}
            <div style={{
              position: 'absolute', bottom: 20, right: 20,
              background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(8px)',
              borderRadius: 8, padding: '6px 14px', color: '#fff', fontSize: 13,
            }}>
              {1}/{imageCount} &#128247;
            </div>
          </div>

          {/* Side thumbnails (desktop only) */}
          {!isMobile && (
            <div style={{ display: 'grid', gridTemplateRows: '1fr 1fr', gap: 8 }}>
              {[1, 2].map(i => (
                <div key={i} style={{
                  background: images[i] ? '#000' : GALLERY_GRADIENTS[i % GALLERY_GRADIENTS.length],
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  cursor: 'pointer', transition: 'opacity 0.2s', overflow: 'hidden',
                }}
                onMouseEnter={e => e.currentTarget.style.opacity = '0.9'}
                onMouseLeave={e => e.currentTarget.style.opacity = '1'}
                onClick={(e) => { e.stopPropagation(); setActiveImage(i); }}
                >
                  {images[i] ? (
                    <img src={images[i]} alt={`${p.title} ${i + 1}`} style={{
                      width: '100%', height: '100%', objectFit: 'cover',
                    }} />
                  ) : (
                    <span style={{ fontSize: 36, opacity: 0.2 }}>&#127963;</span>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Thumbnail strip */}
        <div style={{ display: 'flex', gap: 8, marginTop: 8, overflowX: 'auto', paddingBottom: 4 }}>
          {(images.length > 0 ? images : GALLERY_GRADIENTS).map((item, i) => (
            <div key={i} onClick={() => setActiveImage(i)} style={{
              width: 72, height: 48, borderRadius: 10, flexShrink: 0,
              background: images.length > 0 ? '#000' : item, cursor: 'pointer',
              border: activeImage === i ? '2px solid #e8363a' : '2px solid transparent',
              opacity: activeImage === i ? 1 : 0.6,
              transition: 'all 0.2s',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              overflow: 'hidden',
            }}>
              {images.length > 0 ? (
                <img src={item} alt={`thumb ${i + 1}`} style={{
                  width: '100%', height: '100%', objectFit: 'cover',
                }} />
              ) : (
                <span style={{ fontSize: 16, opacity: 0.3 }}>&#127963;</span>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* ═══ FULLSCREEN VIEWER ═══ */}
      {fullscreen && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 2000,
          background: 'rgba(0,0,0,0.95)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }} onClick={() => setFullscreen(false)}>
          <button onClick={() => setFullscreen(false)} style={{
            position: 'absolute', top: 20, right: 20,
            background: 'rgba(255,255,255,0.1)', border: 'none', color: '#fff',
            width: 44, height: 44, borderRadius: '50%', fontSize: 20, cursor: 'pointer',
          }}>&times;</button>
          <button onClick={(e) => { e.stopPropagation(); setActiveImage(prev => (prev - 1 + imageCount) % imageCount); }} style={{
            position: 'absolute', left: 20, background: 'rgba(255,255,255,0.1)',
            border: 'none', color: '#fff', width: 48, height: 48, borderRadius: '50%',
            fontSize: 20, cursor: 'pointer',
          }}>&#8592;</button>
          <div style={{
            width: '80vw', height: '70vh', borderRadius: 16,
            background: images.length > 0 ? '#000' : GALLERY_GRADIENTS[activeImage % GALLERY_GRADIENTS.length],
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            overflow: 'hidden',
          }}>
            {images.length > 0 ? (
              <img src={images[activeImage % images.length]} alt={p.title} style={{
                maxWidth: '100%', maxHeight: '100%', objectFit: 'contain',
              }} />
            ) : (
              <span style={{ fontSize: 80, opacity: 0.2 }}>&#127963;</span>
            )}
          </div>
          <button onClick={(e) => { e.stopPropagation(); setActiveImage(prev => (prev + 1) % imageCount); }} style={{
            position: 'absolute', right: 20, background: 'rgba(255,255,255,0.1)',
            border: 'none', color: '#fff', width: 48, height: 48, borderRadius: '50%',
            fontSize: 20, cursor: 'pointer',
          }}>&#8594;</button>
        </div>
      )}

      {/* ═══ CONTENT ═══ */}
      <div style={{
        maxWidth: 1200, margin: '0 auto',
        padding: isMobile ? '24px 16px' : '32px 48px',
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : '1fr 380px',
        gap: 32,
      }}>
        {/* Left Column: Main Info */}
        <div>
          {/* Title & Price */}
          <div style={{ marginBottom: 32 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8, flexWrap: 'wrap' }}>
              <span style={{
                background: isCoworking ? 'rgba(114,46,209,0.1)' : isOffice ? 'rgba(22,119,255,0.1)' : 'rgba(26,26,46,0.06)',
                borderRadius: 8, padding: '4px 12px',
                fontSize: 12, fontWeight: 600,
                color: isCoworking ? '#722ed1' : isOffice ? '#1677ff' : '#1a1a2e',
              }}>
                {isCoworking ? t.coworkingTag : isOffice ? t.officeTag : (p.property_type || 'Condo')}
              </span>
              <span style={{
                background: p.listing_type === 'rent' ? 'rgba(79,172,254,0.1)' : 'rgba(67,233,123,0.1)',
                color: p.listing_type === 'rent' ? '#4facfe' : '#2da44e',
                borderRadius: 8, padding: '4px 12px', fontSize: 12, fontWeight: 600,
              }}>{p.listing_type === 'rent' ? t.forRent : t.forSale}</span>
              {p.source_type && sourceName && (
                <span style={{
                  background: 'rgba(0,0,0,0.04)', borderRadius: 8, padding: '4px 12px',
                  fontSize: 11, fontWeight: 600, color: '#888',
                }}>
                  {t.source}: {sourceName}
                </span>
              )}
            </div>
            <h1 style={{
              fontSize: isMobile ? 26 : 36, fontWeight: 800, color: '#1a1a2e',
              lineHeight: 1.2, letterSpacing: -0.5, marginBottom: 8,
            }}>
              {p.title}
            </h1>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#888', fontSize: 15, marginBottom: 16 }}>
              &#128205; {p.district || p.location}{p.address ? ` · ${p.address}` : ''}
            </div>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, flexWrap: 'wrap' }}>
              <div style={{ fontSize: isMobile ? 28 : 36, fontWeight: 800, color: '#e8363a', letterSpacing: -0.5 }}>
                {fmtPrice(p.price, p.currency)}
                {p.listing_type === 'rent' && <span style={{ fontSize: 16, fontWeight: 400, color: '#999' }}>{t.perMonth}</span>}
              </div>
              {perPing && (
                <div style={{ fontSize: 14, color: '#a07d1f', fontWeight: 600, background: 'rgba(212,165,55,0.12)', padding: '4px 12px', borderRadius: 8 }}>
                  {t.perPing} {fmtPrice(perPing)}
                </div>
              )}
              {p.price_per_sqm && !isCoworking && (
                <div style={{ fontSize: 13, color: '#999' }}>
                  ({p.price_per_sqm.toLocaleString()} {t.perSqm})
                </div>
              )}
            </div>
            {p.rating_avg != null ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 10 }}>
                <span style={{ fontSize: 18, color: '#d4a537' }}>&#9733;</span>
                <span style={{ fontSize: 16, fontWeight: 700, color: '#1a1a2e' }}>{p.rating_avg}</span>
                <span style={{ fontSize: 13, color: '#999' }}>({p.rating_count} {t.rating})</span>
                <span style={{ marginLeft: 12, fontSize: 13, color: '#666' }}>{t.myRating}:</span>
                <span onClick={() => { if (!ratingSubmitting) handleRate(myRating ? 0 : 5); }} style={{ cursor: 'pointer', fontSize: 16, color: myRating ? '#d4a537' : '#ccc' }} title={t.rateNow}>
                  {myRating ? '\u2605'.repeat(myRating) + '\u2606'.repeat(5 - myRating) : '\u2606\u2606\u2606\u2606\u2606'}
                </span>
                {myRating ? (
                  <button onClick={() => handleRate(0)} style={{ background: 'none', border: 'none', color: '#e8363a', fontSize: 12, cursor: 'pointer' }}>
                    {t.clearRating}
                  </button>
                ) : (
                  <span style={{ fontSize: 12, color: '#bbb' }}>{t.rateNow}</span>
                )}
              </div>
            ) : (
              <div style={{ fontSize: 13, color: '#999', marginTop: 8 }}>{t.noRatingText}</div>
            )}
          </div>

          {/* Specs Bar */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(5, 1fr)',
            gap: 12, marginBottom: 40,
          }}>
            {specs.map((spec, i) => (
              <div key={i} style={{
                background: '#fff', borderRadius: 14, padding: '16px 12px',
                textAlign: 'center', boxShadow: '0 2px 12px rgba(0,0,0,0.03)',
              }}>
                <div style={{ fontSize: 20, marginBottom: 6 }}>{spec.icon}</div>
                <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a2e', marginBottom: 2 }}>{spec.value}</div>
                <div style={{ fontSize: 12, color: '#999' }}>{spec.label}</div>
              </div>
            ))}
          </div>

          {/* Description */}
          {p.description && (
            <div style={{
              background: '#fff', borderRadius: 20, padding: isMobile ? 24 : 32,
              boxShadow: '0 2px 12px rgba(0,0,0,0.03)', marginBottom: 24,
            }}>
              <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1a1a2e', marginBottom: 16 }}>{t.description}</h2>
              <p style={{ fontSize: 15, color: '#555', lineHeight: 1.8, whiteSpace: 'pre-line' }}>
                {p.ai_description || p.description}
              </p>
            </div>
          )}

          {/* AI Selling Points */}
          {(p.ai_selling_points || []).length > 0 && (
            <div style={{
              background: 'linear-gradient(135deg, rgba(212,165,55,0.06), rgba(212,165,55,0.02))',
              border: '1px solid rgba(212,165,55,0.15)',
              borderRadius: 20, padding: isMobile ? 24 : 32, marginBottom: 24,
            }}>
              <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1a1a2e', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
                &#10024; {t.aiSelling}
              </h2>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                {(Array.isArray(p.ai_selling_points) ? p.ai_selling_points : []).map((point, i) => (
                  <span key={i} style={{
                    background: '#fff', borderRadius: 10, padding: '8px 16px',
                    fontSize: 14, color: '#1a1a2e', fontWeight: 500,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                    display: 'flex', alignItems: 'center', gap: 6,
                  }}>
                    <span style={{ color: '#d4a537' }}>&#9679;</span> {point}
                  </span>
                ))}
              </div>
            </div>
          )}

          {/* Location */}
          <div style={{
            background: '#fff', borderRadius: 20, padding: isMobile ? 24 : 32,
            boxShadow: '0 2px 12px rgba(0,0,0,0.03)', marginBottom: 24,
          }}>
            <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1a1a2e', marginBottom: 16 }}>{t.locationTitle}</h2>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 16, color: '#555', fontSize: 15 }}>
              &#128205; {p.district || p.location}{p.address ? `, ${p.address}` : ''}
            </div>

            {/* Google Maps link / preview */}
            <div style={{
              height: 200, borderRadius: 14, marginBottom: 16, overflow: 'hidden', position: 'relative',
              background: 'linear-gradient(135deg, #e8e8e8, #d0d0d0)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: '#999', fontSize: 14,
            }}>
              {p.latitude && p.longitude ? (
                <img
                  src={`https://maps.googleapis.com/maps/api/staticmap?center=${p.latitude},${p.longitude}&zoom=15&size=600x300&markers=color:red%7C${p.latitude},${p.longitude}&key=`}
                  alt="map"
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  onError={e => { e.target.style.display = 'none'; }}
                />
              ) : null}
              <div style={{ position: 'absolute', fontSize: 24, opacity: 0.3 }}>&#128506;</div>
              {!p.latitude && (
                <div style={{ position: 'absolute', textAlign: 'center', padding: 20 }}>
                  {t.mapFallback} - {p.district || p.location || ''}
                </div>
              )}
            </div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {gmap && (
                <a href={gmap} target="_blank" rel="noreferrer" style={{
                  padding: '10px 20px', borderRadius: 10, fontSize: 14, fontWeight: 600,
                  background: '#1677ff', color: '#fff', textDecoration: 'none',
                }}>
                  &#128506; {t.googleMap}
                </a>
              )}
              {lineUrl && (
                <a href={lineUrl} target="_blank" rel="noreferrer" style={{
                  padding: '10px 20px', borderRadius: 10, fontSize: 14, fontWeight: 600,
                  background: '#06c755', color: '#fff', textDecoration: 'none',
                }}>
                  &#128172; {t.lineAsk}
                </a>
              )}
              {p.source_url && (
                <a href={p.source_url} target="_blank" rel="noreferrer" style={{
                  padding: '10px 20px', borderRadius: 10, fontSize: 14, fontWeight: 600,
                  background: '#722ed1', color: '#fff', textDecoration: 'none',
                }}>
                  &#127760; {t.sourceSite}
                </a>
              )}
            </div>

            {/* Nearby Transit */}
            {(p.nearby_transit || []).length > 0 && (
              <div style={{ marginTop: 20 }}>
                <h4 style={{ fontSize: 14, fontWeight: 700, color: '#1a1a2e', marginBottom: 10 }}>{t.nearbyTransit}</h4>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {(Array.isArray(p.nearby_transit) ? p.nearby_transit : []).map((tr, i) => {
                    const trName = typeof tr === 'string' ? tr : (tr.name || '');
                    const trType = typeof tr === 'string' ? '' : (tr.type || '');
                    return (
                      <span key={i} style={{
                        background: trType === 'bts' ? 'rgba(67,160,71,0.1)' : 'rgba(114,46,209,0.1)',
                        borderRadius: 8, padding: '6px 14px',
                        fontSize: 13, color: trType === 'bts' ? '#43a047' : '#722ed1',
                        fontWeight: 600,
                      }}>
                        &#128650; {trType ? `${trType.toUpperCase()} ` : ''}{trName}
                      </span>
                    );
                  })}
                </div>
              </div>
            )}
          </div>

          {/* Amenities */}
          {(p.amenities || []).length > 0 && (
            <div style={{
              background: '#fff', borderRadius: 20, padding: isMobile ? 24 : 32,
              boxShadow: '0 2px 12px rgba(0,0,0,0.03)', marginBottom: 24,
            }}>
              <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1a1a2e', marginBottom: 20 }}>{t.amenities}</h2>
              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
                gap: 12,
              }}>
                {(Array.isArray(p.amenities) ? p.amenities : []).map((am, i) => (
                  <div key={i} style={{
                    background: '#f5f5fa', borderRadius: 12, padding: '14px',
                    display: 'flex', alignItems: 'center', gap: 8,
                    fontSize: 14, color: '#333',
                  }}>
                    <span style={{ fontSize: 18 }}>{AMENITY_ICONS[am] || '\u2714\ufe0f'}</span>
                    {am}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Nearby POIs (office/coworking) */}
          {(p.nearby_pois || []).length > 0 && (
            <div style={{
              background: '#fff', borderRadius: 20, padding: isMobile ? 24 : 32,
              boxShadow: '0 2px 12px rgba(0,0,0,0.03)', marginBottom: 24,
            }}>
              <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1a1a2e', marginBottom: 4 }}>
                &#9889; {t.nearbyPois}
              </h2>
              <p style={{ color: '#999', fontSize: 13, marginBottom: 16 }}>{t.poiHint}</p>
              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(3, 1fr)',
                gap: 12,
              }}>
                {(Array.isArray(p.nearby_pois) ? p.nearby_pois : []).map((poi, i) => (
                  <a key={i} href={poi.link} target="_blank" rel="noreferrer" style={{
                    textDecoration: 'none', display: 'block',
                    background: '#f5f5fa', borderRadius: 14, overflow: 'hidden',
                    border: '1px solid rgba(0,0,0,0.03)', transition: 'all 0.2s',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.08)'; }}
                  onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; }}
                  >
                    {poi.photo ? (
                      <img src={proxyUrl(poi.photo)} alt={poi.name} style={{
                        width: '100%', height: 110, objectFit: 'cover',
                      }} onError={e => { e.target.style.display = 'none'; }} />
                    ) : (
                      <div style={{
                        height: 110, background: '#eee',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 40,
                      }}>
                        {POI_ICONS[poi.category] || '\ud83d\udccd'}
                      </div>
                    )}
                    <div style={{ padding: '12px 14px' }}>
                      <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1a2e' }}>{poi.name}</div>
                      <div style={{ fontSize: 12, color: '#999', marginTop: 2 }}>
                        {poi.category_zh || poi.category} · ~{poi.distance_km} km
                      </div>
                      <div style={{ fontSize: 12, color: '#1677ff', marginTop: 4 }}>&#127760; Google Maps</div>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          )}

          {/* Nearby Stays (hotels & Airbnb) */}
          {(p.nearby_hotels || []).length > 0 && (
            <div style={{
              background: '#fff', borderRadius: 20, padding: isMobile ? 24 : 32,
              boxShadow: '0 2px 12px rgba(0,0,0,0.03)', marginBottom: 24,
            }}>
              <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1a1a2e', marginBottom: 4 }}>
                &#127976; {t.nearbyStays}
              </h2>
              <p style={{ color: '#999', fontSize: 13, marginBottom: 16 }}>{t.stayHint}</p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {(Array.isArray(p.nearby_hotels) ? p.nearby_hotels : []).map((h, i) => (
                  <a key={i} href={h.link} target="_blank" rel="noreferrer" style={{
                    textDecoration: 'none', display: 'flex', gap: 14, alignItems: 'flex-start',
                    background: '#f5f5fa', borderRadius: 14, padding: '14px 16px',
                  }}>
                    <span style={{ fontSize: 24 }}>{h.type === 'airbnb' ? '\ud83c\udfe1' : '\ud83c\udfe8'}</span>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 14, fontWeight: 700, color: '#1a1a2e' }}>{h.name}</div>
                      <div style={{ fontSize: 12, color: '#999', marginTop: 2 }}>
                        {h.type === 'airbnb' ? 'Airbnb' : '\u98ef\u5e97'} · ~{h.distance_km} km · {h.price}
                      </div>
                      {h.note_zh && <div style={{ fontSize: 12, color: '#666', marginTop: 2 }}>{h.note_zh}</div>}
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
                        {h.rating != null && (
                          <span style={{ fontSize: 12, color: '#d4a537', fontWeight: 600 }}>&#9733; {h.rating}</span>
                        )}
                        <span style={{ fontSize: 12, color: '#1677ff' }}>&#127760; {t.viewDetails}</span>
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          )}

          {/* Property Chat */}
          <div style={{
            background: '#fff', borderRadius: 20, padding: isMobile ? 24 : 32,
            boxShadow: '0 2px 12px rgba(0,0,0,0.03)', marginBottom: 24,
          }}>
            <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1a1a2e', marginBottom: 4 }}>&#129302; {t.askAnything}</h2>
            <p style={{ color: '#999', fontSize: 13, marginBottom: 20 }}>AI-powered instant answers about this property</p>

            <div style={{
              maxHeight: 300, overflowY: 'auto', marginBottom: 16,
              display: 'flex', flexDirection: 'column', gap: 10,
            }}>
              {chatMessages.length === 0 && (
                <div style={{
                  background: '#f5f5fa', borderRadius: 14, padding: '12px 16px',
                  fontSize: 14, color: '#666', lineHeight: 1.6, maxWidth: '80%',
                }}>
                  I can answer any questions about this property. Ask me about the building, amenities, neighborhood, or pricing!
                </div>
              )}
              {chatMessages.map((msg, i) => (
                <div key={i} style={{
                  alignSelf: msg.role === 'user' ? 'flex-end' : 'flex-start',
                  background: msg.role === 'user' ? 'linear-gradient(135deg, #1a1a2e, #0f3460)' : '#f5f5fa',
                  color: msg.role === 'user' ? '#fff' : '#333',
                  borderRadius: 14, padding: '12px 16px',
                  fontSize: 14, lineHeight: 1.5, maxWidth: '80%',
                }}>
                  {msg.content}
                </div>
              ))}
              {chatSending && (
                <div style={{ display: 'flex', gap: 4, padding: '8px 12px' }}>
                  {[0, 1, 2].map(i => (
                    <span key={i} style={{
                      width: 7, height: 7, borderRadius: '50%', background: '#ccc',
                      animation: `houseTyping 1s ease ${i * 0.15}s infinite`,
                    }} />
                  ))}
                </div>
              )}
            </div>

            <div style={{ display: 'flex', gap: 8 }}>
              <input
                value={chatInput}
                onChange={e => setChatInput(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); sendChat(chatInput); } }}
                placeholder={t.chatPlaceholder}
                style={{
                  flex: 1, padding: '12px 16px', borderRadius: 12,
                  border: '1px solid rgba(0,0,0,0.08)', fontSize: 14, outline: 'none',
                  background: '#f5f5fa',
                }}
                onFocus={e => e.target.style.borderColor = '#d4a537'}
                onBlur={e => e.target.style.borderColor = 'rgba(0,0,0,0.08)'}
              />
              <button
                onClick={() => sendChat(chatInput)}
                disabled={!chatInput.trim() || chatSending}
                style={{
                  padding: '12px 24px', borderRadius: 12,
                  background: chatInput.trim() ? 'linear-gradient(135deg, #1a1a2e, #0f3460)' : '#ddd',
                  color: '#fff', border: 'none', fontSize: 14, fontWeight: 600,
                  cursor: chatInput.trim() ? 'pointer' : 'default',
                }}
              >
                {t.sendMsg}
              </button>
            </div>
          </div>

          {/* Similar Properties */}
          {similar.length > 0 && (
            <div>
              <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1a1a2e', marginBottom: 4 }}>{t.similar}</h2>
              <p style={{ color: '#999', fontSize: 13, marginBottom: 20 }}>{t.similarHint}</p>
              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
                gap: 16,
              }}>
                {(similar.length > 0 ? similar : MOCK_SIMILAR).map((sp, i) => (
                  <div key={sp.id || i} onClick={() => navigate(`/h/${slug}/property/${sp.id || i + 1}`)} style={{
                    background: '#fff', borderRadius: 16, overflow: 'hidden',
                    cursor: 'pointer', boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
                    transition: 'all 0.3s ease',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 8px 28px rgba(0,0,0,0.08)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.04)'; }}
                  >
                    <div style={{
                      height: 140, background: sp.images?.[0] ? '#000' : (sp.gradient || GALLERY_GRADIENTS[i % GALLERY_GRADIENTS.length]),
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      overflow: 'hidden',
                    }}>
                      {sp.images?.[0] ? (
                        <img src={proxyUrl(sp.images[0])} alt={sp.title} style={{
                          width: '100%', height: '100%', objectFit: 'cover',
                        }} />
                      ) : (
                        <span style={{ fontSize: 28, opacity: 0.2 }}>&#127963;</span>
                      )}
                    </div>
                    <div style={{ padding: '14px 16px' }}>
                      <h4 style={{ fontSize: 14, fontWeight: 700, color: '#1a1a2e', marginBottom: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {sp.title}
                      </h4>
                      <div style={{ fontSize: 12, color: '#999', marginBottom: 8 }}>
                        &#128205; {sp.district || sp.location}
                        {sp.similar_reasons && sp.similar_reasons.length > 0 && (
                          <span style={{ marginLeft: 6, color: '#1677ff' }}>
                            {sp.similar_reasons.map(r => t.reasons?.[REASON_KEYS[r] || r] || r).join(' · ')}
                          </span>
                        )}
                      </div>
                      <div style={{ fontSize: 16, fontWeight: 700, color: '#e8363a' }}>
                        {fmtPrice(sp.price, sp.currency)}
                        {sp.listing_type === 'rent' && <span style={{ fontSize: 12, fontWeight: 400, color: '#999' }}>{t.perMonth}</span>}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* ═══ RIGHT SIDEBAR ═══ */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
          {/* CTAs */}
          <div style={{
            background: '#fff', borderRadius: 20, padding: 24,
            boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
            position: isMobile ? 'relative' : 'sticky', top: 104,
          }}>
            <div style={{ fontSize: 28, fontWeight: 800, color: '#e8363a', marginBottom: 4 }}>
              {fmtPrice(p.price, p.currency)}
            </div>
            {p.listing_type === 'rent' && <span style={{ fontSize: 13, color: '#999' }}>{t.perMonth}</span>}
            {ping && perPing && (
              <div style={{ fontSize: 13, color: '#666', marginTop: 4 }}>
                {p.area_sqm} {t.sqm} = {ping} {t.ping} · {t.perPing} {fmtPrice(perPing)}
              </div>
            )}

            <div style={{ borderTop: '1px solid rgba(0,0,0,0.06)', margin: '16px 0', paddingTop: 16 }}>
              {gmap && (
                <a href={gmap} target="_blank" rel="noreferrer" style={{
                  display: 'block', width: '100%', padding: '16px', marginBottom: 12,
                  background: 'linear-gradient(135deg, #1677ff, #0e5fd8)',
                  color: '#fff', border: 'none', borderRadius: 14,
                  fontSize: 15, fontWeight: 700, cursor: 'pointer', textAlign: 'center',
                  textDecoration: 'none', boxShadow: '0 4px 16px rgba(22,119,255,0.3)',
                }}>
                  &#128506; {t.googleMap}
                </a>
              )}
              {lineUrl && (
                <a href={lineUrl} target="_blank" rel="noreferrer" style={{
                  display: 'block', width: '100%', padding: '16px', marginBottom: 12,
                  background: 'linear-gradient(135deg, #06c755, #05b14c)',
                  color: '#fff', border: 'none', borderRadius: 14,
                  fontSize: 15, fontWeight: 700, cursor: 'pointer', textAlign: 'center',
                  textDecoration: 'none', boxShadow: '0 4px 16px rgba(6,199,85,0.3)',
                }}>
                  &#128172; {t.lineAsk}
                </a>
              )}
              {p.source_url && (
                <a href={p.source_url} target="_blank" rel="noreferrer" style={{
                  display: 'block', width: '100%', padding: '16px',
                  background: 'linear-gradient(135deg, #722ed1, #5b21b6)',
                  color: '#fff', border: 'none', borderRadius: 14,
                  fontSize: 15, fontWeight: 700, cursor: 'pointer', textAlign: 'center',
                  textDecoration: 'none', boxShadow: '0 4px 16px rgba(114,46,209,0.3)',
                }}>
                  &#127760; {t.sourceSite}
                </a>
              )}
              {!gmap && !lineUrl && !p.source_url && (
                <button onClick={() => navigate(`/h/${slug}/chat`)} style={{
                  width: '100%', padding: '16px',
                  background: 'linear-gradient(135deg, #1a1a2e, #0f3460)',
                  color: '#fff', border: 'none', borderRadius: 14,
                  fontSize: 15, fontWeight: 700, cursor: 'pointer',
                }}>
                  &#129302; {t.askAnything}
                </button>
              )}
            </div>
          </div>

          {/* Inquiry Form */}
          <div style={{
            background: '#fff', borderRadius: 20, padding: 24,
            boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
          }}>
            <h3 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a2e', marginBottom: 20 }}>{t.inquiry}</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {[
                { key: 'name', placeholder: t.name, type: 'text' },
                { key: 'email', placeholder: t.email, type: 'email' },
                { key: 'phone', placeholder: t.phone, type: 'tel' },
              ].map(f => (
                <input
                  key={f.key}
                  type={f.type}
                  placeholder={f.placeholder}
                  value={formData[f.key]}
                  onChange={e => setFormData(prev => ({ ...prev, [f.key]: e.target.value }))}
                  style={{
                    padding: '14px 16px', borderRadius: 12,
                    border: '1px solid rgba(0,0,0,0.08)', fontSize: 14,
                    outline: 'none', background: '#f9f9fb',
                    transition: 'border-color 0.2s',
                  }}
                  onFocus={e => e.target.style.borderColor = '#d4a537'}
                  onBlur={e => e.target.style.borderColor = 'rgba(0,0,0,0.08)'}
                />
              ))}
              <textarea
                placeholder={t.message}
                value={formData.message}
                onChange={e => setFormData(prev => ({ ...prev, message: e.target.value }))}
                rows={3}
                style={{
                  padding: '14px 16px', borderRadius: 12,
                  border: '1px solid rgba(0,0,0,0.08)', fontSize: 14,
                  outline: 'none', background: '#f9f9fb', resize: 'vertical',
                  fontFamily: 'inherit',
                }}
                onFocus={e => e.target.style.borderColor = '#d4a537'}
                onBlur={e => e.target.style.borderColor = 'rgba(0,0,0,0.08)'}
              />
              <button
                onClick={handleFormSubmit}
                style={{
                  padding: '16px',
                  background: formSent ? 'linear-gradient(135deg, #43e97b, #38f9d7)' : 'linear-gradient(135deg, #d4a537, #f0c75e)',
                  color: '#1a1a2e', border: 'none', borderRadius: 12,
                  fontSize: 15, fontWeight: 700, cursor: 'pointer',
                  transition: 'all 0.3s ease',
                }}
              >
                {formSent ? t.sent : t.submit}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
